enum DossierTaskAbsenceReason {
	Illness = "Illness",
	Vacation = "Vacation"
}

export default DossierTaskAbsenceReason;